module.exports = __webpack_public_path__ + "img/ic_word.a2417dcd.svg";